"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("../../stylesheets/views/intranet/IntranetHeader.css");

var _react = _interopRequireDefault(require("react"));

var _formatters = _interopRequireDefault(require("../../util/formatters"));

var _classnames = _interopRequireDefault(require("classnames"));

var _mobxReact = require("mobx-react");

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _constants = require("../../util/constants");

var _environmentUtilities = _interopRequireDefault(require("../../util/environmentUtilities"));

var _toUpper = _interopRequireDefault(require("lodash/toUpper"));

var _moment = _interopRequireDefault(require("moment"));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var IntranetHeader = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(IntranetHeader, _React$Component);

  var _super = _createSuper(IntranetHeader);

  function IntranetHeader() {
    _classCallCheck(this, IntranetHeader);

    return _super.apply(this, arguments);
  }

  _createClass(IntranetHeader, [{
    key: "render",
    value: function render() {
      var _session$environmentN,
          _session$currentUtc,
          _this = this;

      var session = this.props.session;
      var environmentName = (0, _toUpper.default)((_session$environmentN = session === null || session === void 0 ? void 0 : session.environmentName) !== null && _session$environmentN !== void 0 ? _session$environmentN : "");
      var user = session === null || session === void 0 ? void 0 : session.user;

      var isProd = _environmentUtilities.default.isProdIntra(session);

      var currentUtc = (_session$currentUtc = session === null || session === void 0 ? void 0 : session.currentUtc) !== null && _session$currentUtc !== void 0 ? _session$currentUtc : _moment.default.utc();
      var envClasses = {
        environment: true,
        prod: isProd
      };
      var headerClasses = {
        "intranet-header": true,
        "prod-header": isProd
      };

      var roleString = function () {
        if (_this.props.hasOpsAdminRole) {
          return "ADMIN";
        }

        return "USER";
      }();

      var roleClasses = {
        role: true,
        admin: this.props.hasOpsAdminRole
      };
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("header", {
        className: (0, _classnames.default)(headerClasses)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "title"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.HOME
      }, "gradifi")), /*#__PURE__*/_react.default.createElement("div", {
        className: "status"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(roleClasses)
      }, roleString), environmentName && /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(envClasses)
      }, environmentName), user && user.email && /*#__PURE__*/_react.default.createElement("span", {
        className: "user"
      }, "Logged in as: ", /*#__PURE__*/_react.default.createElement("strong", null, user.email), /*#__PURE__*/_react.default.createElement("div", {
        className: "current-date"
      }, _formatters.default.localDateTimeWithUtcTitle(currentUtc))))));
    }
  }]);

  return IntranetHeader;
}(_react.default.Component)) || _class;

var _default = (0, _Propulator.default)(IntranetHeader, {
  sessionStore: ["session"],
  roleStore: ["hasOpsAdminRole"]
});

exports.default = _default;